<template>
  <el-input placeholder="请输入关键字" v-model="value">
    <el-button slot="append" icon="el-icon-search" @click="onchange"></el-button>
  </el-input>
</template>

<script>
  import VueEvent from "@/models/VueEvent.js";
  export default {
    data() {
      return {
        value: ''
      };
    },
    mounted() {
      VueEvent.$on("data_loaded", params => {
        if (params.origin == this.target) {
          this.total = params.total;
        }
      });
    },
    props: ["target"],
    methods: {
      onchange() {
        if (this.target) {
          VueEvent.$emit("addCondition", {
            target: this.target,
            condition: {
              keywords: this.value
            }
          });
        }
      }
    }
  };

</script>

<style scoped>
  .el-pagination {
    margin-top: 10px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/input/Search.vue